import { render } from "./CodeField.vue?vue&type=template&id=d5fc3d1a&scoped=true"
import script from "./CodeField.vue?vue&type=script&lang=js"
export * from "./CodeField.vue?vue&type=script&lang=js"

import "./CodeField.vue?vue&type=style&index=0&id=d5fc3d1a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5fc3d1a"]])

export default __exports__